import { GroupCommands } from '../commands/GroupCommands';
import { Command } from '../commands/Command';

export function wrapInGroup(groupeTitle: string, commandList: Command[]) {
  if (commandList.length > 0) {
    commandList = [new GroupCommands('[' + groupeTitle + ']', commandList)];
  }
  return commandList;
}
